export default __webpack_public_path__ + "static/media/banner.3f5388e9.png";